// Change Dimension Property Name of Dimension field.
jQuery(document).ready(function ($) {
  //     // $("[name='btss_meta[bts_column][left]']").attr('placeholder', 'Mobile')
  $("[name='_bp3dimages_[angle_property][top]']").attr("placeholder", "X");
  $("[name='_bp3dimages_[angle_property][right]']").attr("placeholder", "Y");
  $("[name='_bp3dimages_[angle_property][bottom]']").attr("placeholder", "Z");
});

document.addEventListener("DOMContentLoaded", function () {
  // custom css
  const subtitleElement = document.querySelector(".custom-css .csf-subtitle-text");
  if (subtitleElement) {
    subtitleElement.innerText = `#bp_model_id_${parseInt(window.post_ID?.value)}`;
  }
});
